<template>
  <div class="mobile-desktop-banner">
    <span class="banner-text">For the best experience, use a desktop browser.</span>
    <a class="banner-link" :href="mailtoLink">Email me this link</a>
  </div>
</template>

<script>
export default {
  name: "MobileDesktopBanner",
  computed: {
    mailtoLink() {
      const url = window.location.origin + this.$route.fullPath;
      const subject = encodeURIComponent('Kiey - Continue on Desktop');
      const body = encodeURIComponent('Continue where you left off:\n\n' + url);
      return `mailto:?subject=${subject}&body=${body}`;
    }
  }
};
</script>

<style scoped>
.mobile-desktop-banner {
  display: none;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: #061D47;
  color: #ffffff;
  font-size: 12px;
  text-align: center;
  flex-wrap: wrap;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
}

.banner-text {
  font-weight: 400;
}

.banner-link {
  color: #29abe2;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
}

.banner-link:hover {
  text-decoration: underline;
}

@media (max-width: 480px) {
  .mobile-desktop-banner {
    display: flex;
  }
}
</style>
